import { safeHref } from '../helpers/safeHref';
import React, {Component} from 'react';
import {Button, Table} from "reactstrap";
import 'moment/locale/fr';
import './Products.css'
import {Download, Edit2, Mail, Trash} from "react-feather";
import {Col, OverlayTrigger, Row, ToggleButton, ToggleButtonGroup, Tooltip} from "react-bootstrap";
import AddUserModalForm from "./modals/AddUserModal";
import DeleteModal from "./modals/DeleteModal";
import Moment from "react-moment";
import CsvDownloadButton from 'react-json-to-csv'
import {AiOutlineInstagram, AiFillLinkedin} from "react-icons/ai";
import {BsFacebook} from "react-icons/bs";
import {BiRun} from "react-icons/bi";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import AddAmbassadorModal from './modals/AddAmbassadorModal';
import ModifyAmbassadorModal from './modals/ModifyAmbassadorModal';
import { apiFetch, API } from "../services/api";

function getAmbassadorApprovedUsers() {

    return apiFetch(API.back + '/ambassador-approved-front-users', {
        method: 'GET',
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

export class AmbassadorApprovedUsersList extends Component {
    state = {
        errors: null,
        csvUsers: null,
    }

    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
    }

    async componentDidMount() {
        await getAmbassadorApprovedUsers().then(data => {
            const uniqueNames = data
                .map(e => e['email'])

                // store the keys of the unique objects
                .map((e, i, final) => final.indexOf(e) === i && i)

                // eliminate the dead keys & store unique objects
                .filter(e => data[e]).map(e => data[e]);
            this.setState({users: uniqueNames})
        }).catch(err =>
            this.setState({errors: "error while getting users"})
        );
    };

    closeModal() {
        this.setState({isOpen: false, isOpenModify: false})
    } 


    render() {
        return (
            <div className="products-list">
                <Row>
                    <Col sm={9} className="products-buttons">
                        {(this.state.users && this.state.errors == null) ? <span>{this.state.users.length} comptes client</span> : null }
                    </Col>
                    <Col sm={3} className="products-buttons">
                        <Button className="add-product-button " variant="secondary" type="submit"
                                onClick={(e) => this.setState({isOpen: true})}>Ajouter un ambassadeur</Button>
                    </Col>
                </Row>

                { (!this.state.users && this.state.errors == null) ? <p> Chargement ...</p>
                    :
                    <Table responsive>
                        <thead>
                        <tr>
                            <th></th>
                            <th>Nom</th>
                            <th>Prénom</th>
                            <th>Sexe</th>
                            <th>Âge</th>
                            <th>Adresse</th>
                            <th>Email</th>
                            <th>Téléphone</th>
                            <th>Profil</th>
                            <th>Réseaux</th>
                            <th>Taille chaussures</th>
                            <th>Taille vêtements</th>
                            <th>Distance</th>
                            <th>Dernière connexion</th>
                            <th>Modifier</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.users && this.state.users.map(user => (
                            <tr>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">Ambassadeur approuvé?</Tooltip>}
                                >
                                    <td><BootstrapSwitchButton
                                        checked={user.isAmbassadorApproved}
                                        onlabel='oui'
                                        onstyle='success'
                                        offlabel='non'
                                        offstyle='danger'
                                        size='xs'
                                        onChange={(checked: boolean) => {
                                            updateContactedState(user, checked)
                                        }}
                                    /></td>
                                </OverlayTrigger>
                                <td>{user.name}</td>
                                <td>{user.firstName}</td>
                                <td>{user.gender}</td>
                                <td>{calculateAge(user.birthdayDate) + " ans"}</td>
                                <td>{user.address} <br/> {user.zipCode} {user.town}</td>
                                <td>{user.email}</td>
                                <td>{user.phoneNumber}</td>
                                <td>{user.type}</td>
                                <td>
                                    {user.instagramLink != "" ? <a href={safeHref(user.instagramLink)} rel="noopener noreferrer" target="_blank"><AiOutlineInstagram size="1rem"/></a> : null}
                                    {user.facebookLink != "" ? <a href={safeHref(user.facebookLink)} rel="noopener noreferrer" target="_blank"><BsFacebook size="1rem"/></a> : null }
                                    {user.linkedInLink != "" ? <a href={safeHref(user.linkedInLink)} rel="noopener noreferrer" target="_blank"><AiFillLinkedin size="1rem"/></a> : null }
                                    {user.raceResultsLink != "" ? <a href={safeHref(user.raceResultsLink)} rel="noopener noreferrer" target="_blank"><BiRun size="1rem"/></a> : null }

                                </td>
                                <td>{user.shoeSize}</td>
                                <td>{user.apparelSize}</td>
                                <td>{user.favoriteDistance}</td>
                                <td><Moment to={user.lastConnexion} locale="fr">{Date.now()}</Moment></td>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">Modifier l'ambassadeur</Tooltip>}
                                >
                                    <td className="table-action" style={{cursor: 'pointer'}}>
                                        <Edit2 className="align-middle mr-1" size={18} onClick={(e) => this.setState({isOpenModify : true, selectedUser : user})}/>
                                    </td>
                                </OverlayTrigger>

                            </tr>
                        ))}
                        </tbody>
                    </Table>
                }
                {this.state.isOpen ?
                    <AddAmbassadorModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isOpen}
                        handleSubmit={this.handleSubmit}
                    />
                    :
                    null
                }
                {this.state.isOpenModify ?
                    <ModifyAmbassadorModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isOpenModify}
                        handleSubmit={this.handleSubmit}
                        user={this.state.selectedUser}
                    />
                    :
                    null
                }
                {this.state.isDelete ?
                    <DeleteModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isDelete}
                        handleSubmit={this.handleSubmit}
                        selectedItem={this.state.selectedUser}
                        selectedCategory="user"
                    />
                    :
                    null
                }
            </div>
        );

    }
}

function updateContactedState(user, checked) {
    user.isAmbassadorApproved = checked
    return fetch('https://back-api.therunningcollective.fr/ambassador-approved-front-user', {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(user)
    }).then()
        .catch( err =>
            console.log(err)
        )
}

const calculateAge = (dob1) => {
    var today = new Date();
    var birthDate = new Date(dob1);  // create a date object directly from `dob1` argument
    var age_now = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate()))
    {
        age_now--;
    }
    return age_now;
}